import columns from './utils/columns'

const state = () => ({
  columns,
})

export default state
